import { EventApiData } from "@/app/api/use-my-clients-overview";

export interface DataWithSessionCount {
  clientId?: undefined | number;
  totalSessionsAttendedWithCurrentClinician?: number | null | undefined;
}

export const getCurrentClinicianAttendedSessions = (
  events: Array<EventApiData>,
  clinicianId?: number,
) => {
  return events?.filter(
    (event: any) =>
      event.appointmentStatus === "attended" &&
      event.clinicianId === clinicianId,
  ).length;
};
